import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { FileUploadModalBody } from '@rd-web-markets/shared/dist/util';
const EmployeeCostImportModal = _ref => {
  let {
    show,
    onHide,
    importTemplate
  } = _ref;
  const {
    t
  } = useTranslation();
  const [uploadAllowed, setUploadAllowed] = useState(false);
  const [fileNotSelected, setFileNotSelected] = useState(false);
  useEffect(() => {
    if (!show) {
      setUploadAllowed(false);
    }
  }, [show]);
  const upload = useCallback(formData => {
    importTemplate(formData);
  }, [importTemplate]);
  const renderBody = /*#__PURE__*/React.createElement(FileUploadModalBody, {
    uploadAllowed: uploadAllowed,
    upload: upload,
    setFileNotSelected: setFileNotSelected
  });
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: t('import_employee_data'),
    show: show,
    renderBody: () => renderBody,
    onHide: onHide,
    onSubmit: () => window.confirm(t('are_you_sure_you_want_to_import_new_data?_if_yes_all_uploaded_documents_will_be_deleted')) && setUploadAllowed(true),
    submitText: t('import'),
    disabled: fileNotSelected
  });
};
export default EmployeeCostImportModal;